<script>
    export default {
        name: "icon",
        props:{
            solid: Boolean,
            brand: Boolean,
            light: Boolean,
            icon: {
                type: String,
                default: 'rebel'
            },
            size: {
                type: Number,
                default: 1
            }
        },
        render(h)
        {
            return h(
                'i',
                {
                    class:  [
                        {
                            'fas': this.solid,
                            'fab': this.brand,
                            'fal': this.light,
                            'far': !this.solid && !this.brand && !this.light
                        },
                        `fa-${this.icon}`,
                    ],
                    style:{
                        'font-size': this.size + 'rem'
                    }

                },
                this.$slots.default
            )
        }
    }
</script>
